import { render } from "./SubprogramList.vue?vue&type=template&id=3cdf0409&scoped=true"
import script from "./SubprogramList.vue?vue&type=script&lang=js"
export * from "./SubprogramList.vue?vue&type=script&lang=js"

import "./SubprogramList.vue?vue&type=style&index=0&id=3cdf0409&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdf0409"]])

export default __exports__